<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="lock-icon"
    width="20.068"
    height="17.786"
    viewBox="0 0 20.068 17.786"
  >
    <g transform="translate(-7930.5 -3534.247)">
      <path
        class="a"
        fill="none"
        :stroke="iconColor"
        d="M-66.975,87.312V89h1.592v-1.7a4.771,4.771,0,0,0-4.771-4.771h-.138a4.771,4.771,0,0,0-4.771,4.771V89h1.588V87.312a3.184,3.184,0,0,1,3.181-3.181h.138A3.184,3.184,0,0,1-66.975,87.312Z"
        transform="translate(8006.063 3452.21)"
      />
      <path
        class="a"
        fill="none"
        :stroke="iconColor"
        d="M272.715,402.274h-9.668a1.3,1.3,0,0,0-1.3,1.3v7.73a1.3,1.3,0,0,0,1.3,1.3h9.668a1.3,1.3,0,0,0,1.3-1.3v-7.73A1.3,1.3,0,0,0,272.715,402.274Zm-3.74,5.013a1.388,1.388,0,0,1-.241.241v1.483a.853.853,0,0,1-1.706,0v-1.483a1.387,1.387,0,1,1,1.947-.241Z"
        transform="translate(7676.052 3138.927)"
      />
    </g>
  </svg>
</template>

<script>
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'
  export default {
    name: 'LockOpen',
    setup() {
      const theme = useTheme()
      const iconColor = computed(() =>
        theme.global.current.value.dark ? '#CECECE' : '#383935'
      )

      return {
        iconColor,
      }
    },
  }
</script>

<style scoped>
  svg {
    width: 20.068px;
    height: 17.786px;
  }
</style>
